<div class="tc-container">
  <editor
    *ngIf="!loading"
    [init]="init"
    [disabled]="true"
    [initialValue]="textoTc"
  ></editor>
</div>
